const fontStacks: Record<string, string> = {
	Inter: '"Inter", Arial, sans-serif',
	Poppins: '"Poppins", Arial, sans-serif',
	Montserrat: '"Montserrat", Arial, sans-serif',
	Nunito: '"Nunito", Arial, sans-serif',
	Roboto: '"Roboto", Arial, sans-serif',
	'Open Sans': '"Open Sans", Arial, sans-serif',
	Lato: '"Lato", Arial, sans-serif',
	'Work Sans': '"Work Sans", Arial, sans-serif',
	Raleway: '"Raleway", Arial, sans-serif',
	'Playfair Display': '"Playfair Display", Georgia, serif',
	Arial: 'Arial, Helvetica, sans-serif',
	Helvetica: 'Helvetica, Arial, sans-serif',
	Georgia: 'Georgia, "Times New Roman", serif',
	'Times New Roman': '"Times New Roman", Times, serif',
};

export const cssFontFamily = (value: string): string => {
	const family = value.trim() || 'Helvetica';
	if (fontStacks[family]) return fontStacks[family];
	const safeFamily = family.replace(/["\\;{}\r\n]/g, '').trim() || 'Helvetica';
	if (safeFamily.includes(',')) return safeFamily;
	return `"${safeFamily}", Arial, sans-serif`;
};
